const guest = {
    namespaced: true,
    state: {
        isProd: true,
        isAuth: false,
        isLoading: false,
        quantityType: 'Quantity',
        couponErrorMsg: "",
        couponSuccessMsg: "",
        submitMsgType: "",
        submitFormMsg: "",
        submitSuccessRedirectUrl: "",
        categories: [],
        products: [],
        productDetail: {
            cartUpdated: false,
            cartAdded: false,
            cartAddedMsg: 'Item has been added to cart.',
            errMessage: null,
            product: {},
            input: {
                product_id: '',
                quantity: 1,
                bundle_id: '',
                type: '',
            },
            bundle: {},
            bundle_items: [],
            currentURL: "",
            lastBundleItems: "",
            totalRetailPrice: "0.00",
            totalDiscountPrice: "0.00",
            totalPriceSave: "0.00",
            totalComboItems: [],
        },
        carts: {
            items: {},
            config: {bucket_url: "https://storage.googleapis.com/aafiyat2u-assets/"},
            referral_by: "",
            quantity_type: "Carton",
            item_total: 0,
            item_quantity: 0,
            sub_total: "0.00",
            sub_total_discounted: "0.00",
            shipping_data: null,
            shipping_amount: "0.00",
            discount_total: 0,
            voucher_code: "",
            grand_total: "0.00",
        },
        voucher: {
            voucher_code: "",
            voucher_discount: 0,
            voucher_message: "",
            voucher_status: "",
        },
    },
    getters: {
        isLoading: state => {
            return state.isLoading;
        },
        isProd: state => {
            return state.isProd;
        },
        isAuth: state => {
            return state.isAuth;
        },
        categories: state => {
            return state.categories;
        },
        products: state => {
            return state.products;
        },
        quantityType: state => {
            return state.quantityType;
        },
        carts: state => {
            return state.carts;
        },
        submitMsgType: state => {
            return state.submitMsgType;
        },
        submitFormMsg: state => {
            return state.submitFormMsg;
        },
        submitSuccessRedirectUrl: state => {
            return state.submitSuccessRedirectUrl;
        },
        productDetail: state => {
            return state.productDetail;
        },
        voucher: state => {
            return state.voucher;
        },
    },
    actions: {
        fetchCart({commit}) {
            commit("isLoading", true);

            return axios.get('/api/ajax/public/carts')
                .then(res => {
                    commit("carts", res);
                    commit("isLoading", false);
                })
                .catch(err => {
                    commit("isLoading", false);
                });
        },
        getCategories({commit}) {
            commit("isLoading", true);

            return axios.get('/api/ajax/public/categories')
                .then(res => {
                    commit("categoryLists", res.data.data);
                    commit("isLoading", false);
                })
                .catch(err => {
                    commit("isLoading", false);
                });
        },
        getsubCategories({commit}, categoryId) {
            commit("isLoading", true);

            return axios.get(`/api/ajax/public/subcategories/${categoryId}`)
                .then(res => {
                    commit("categoryLists", res.data.data);
                    commit("isLoading", false);
                })
                .catch(err => {
                    commit("isLoading", false);
                });
        },
        getProducts({commit}, categoryId) {
            commit("isLoading", true);

            return axios.get(`/api/ajax/public/products/${categoryId}`)
                .then(res => {
                    commit("productLists", res.data.data);
                    commit("isLoading", false);
                })
                .catch(err => {
                    commit("isLoading", false);
                });
        },
        getProductDetails({commit}, id) {
            commit("isLoading", true);

            return axios.get(`/api/ajax/public/product-details/${id}`)
                .then(res => {
                    commit("productDetail", res);
                    commit("bundles", res);
                    commit("isLoading", false);
                })
                .catch(err => {
                    commit("isLoading", false);
                });
        },
        removeItem({commit, dispatch}, rowId) {
            if (confirm('Confirm remove item?')) {
                commit("isLoading", true);

                return axios.delete(`/api/ajax/public/carts/${rowId}`)
                    .then(res => {
                        dispatch("fetchCart");
                        commit("isLoading", false);
                    }).catch(err => {
                        dispatch("fetchCart");
                        commit("isLoading", false);
                    });
            }
        },
        incQty({commit, getters, dispatch}, payload) {
            commit("isLoading", true);

            let rowId = payload.rowId
            let amt = payload.amt
            let qty = parseInt(getters.carts.items[rowId].quantity) + parseInt(amt);
            return axios.put(`/api/ajax/public/carts/${rowId}`, {
                quantity: qty
            }).then(res => {
                commit("setItemQuantity", {rowId: rowId, qty: qty});
                dispatch("fetchCart");
                commit("isLoading", false);
            }).catch(err => {
                commit("isLoading", false);
            });
        },
        decQty({commit, getters, dispatch}, payload) {
            let rowId = payload.rowId
            let amt = payload.amt

            if (getters.carts.items[rowId].quantity == 1 || getters.carts.items[rowId].quantity < 0) return

            let qty = getters.carts.items[rowId].quantity -= amt;

            commit("isLoading", true);

            return axios.put(`/api/ajax/public/carts/${rowId}`, {
                quantity: qty
            })
                .then(res => {
                    commit("setItemQuantity", {rowId: rowId, qty: qty});
                    dispatch("fetchCart");
                    commit("isLoading", false);
                }).catch(err => {
                    commit("isLoading", false);
                });
        },
        updateItemQuantity({commit, getters, dispatch}, payload) {
            let item = payload.item
            let event = payload.$event

            let qty = Number(event.target.value);

            if (qty >= 1 && qty < 1000) {
                commit("isLoading", true);

                return axios.put(`/api/ajax/public/carts/${item.rowId}`, {
                    quantity: qty
                })
                    .then(res => {
                        commit("setItemQuantity", {rowId: item.rowId, qty: qty});
                        dispatch("fetchCart");
                        commit("isLoading", false);
                    })
                    .catch(err => {
                        commit("setItemQuantity", {rowId: item.rowId, qty: item.qty});
                        commit("isLoading", false);
                    })
            };
        },
        updateBulkQuantities({commit, getters, dispacth}) {
            commit("isLoading", true);

            return axios.post(`/api/ajax/public/update-bulk-quantities`, {
                items: getters.carts.items
            })
                .then(res => {
                    dispatch("fetchCart");
                    commit("isLoading", false);
                });
        },
        clearCarts({commit, dispatch}) {
            if (confirm('Confirm clear cart?')) {
                commit("isLoading", true);

                return axios.post(`/api/ajax/public/clear-carts`).then(res => {
                    dispatch("fetchCart");
                    commit("isLoading", false);
                });
            }
        },
        hideCartUpdated({commit, dispatch}) {
            commit("cartUpdated", false)
        },
    },
    mutations: {
        isLoading(state, bool) {
            state.isLoading = bool;
        },
        categoryLists(state, data) {
            state.categories = data;
        },
        productLists(state, data) {
            state.products = data;
        },
        productDetail(state, res) {
            state.productDetail.product = res.data.data;
        },
        bundles(state, res) {
            state.productDetail.bundle = res.data.data.bundle;
            state.productDetail.bundle_items = res.data.data.bundle.items;
        },
        setItemQuantity(state, {rowId, qty}) {
            state.carts.items[rowId].quantity = qty
        },
        carts(state, res) {
            state.carts = res.data.data;
        },
        cartUpdated(state, payload) {
            state.productDetail.cartUpdated = payload;
        },
    },
};

export default guest;